(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const TIME_ZONE = 'Europe/Bucharest';

    const FIXED_HOLIDAYS = [
      '01-01', '01-02', '01-06', '01-07', '01-24',
      '05-01', '06-01', '08-15', '11-30', '12-01',
      '12-25', '12-26'
    ];

    // Pentru zile proprii fără expediere (inventar, concediu etc.), adaugă date YYYY-MM-DD.
    const EXTRA_CLOSED_DATES = [];

    const bucharestFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const roDateFormatter = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });

    function getBucharestParts(date) {
      const parts = {};
      bucharestFormatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return {
        year: parts.year,
        month: parts.month,
        day: parts.day,
        hour: parts.hour,
        minute: parts.minute,
        second: parts.second
      };
    }

    function dateKey(date) {
      return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }

    function monthDayKey(date) {
      return `${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }

    function addCalendarDays(date, days) {
      const value = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
      return {
        year: value.getUTCFullYear(),
        month: value.getUTCMonth() + 1,
        day: value.getUTCDate()
      };
    }

    function weekday(date) {
      return new Date(Date.UTC(date.year, date.month - 1, date.day)).getUTCDay();
    }

    function orthodoxEaster(year) {
      const a = year % 4;
      const b = year % 7;
      const c = year % 19;
      const d = (19 * c + 15) % 30;
      const e = (2 * a + 4 * b - d + 34) % 7;
      const julianMonth = Math.floor((d + e + 114) / 31);
      const julianDay = ((d + e + 114) % 31) + 1;
      const julianDate = new Date(Date.UTC(year, julianMonth - 1, julianDay + 13));

      return {
        year: julianDate.getUTCFullYear(),
        month: julianDate.getUTCMonth() + 1,
        day: julianDate.getUTCDate()
      };
    }

    function movableHolidayKeys(year) {
      const easter = orthodoxEaster(year);
      return new Set([
        dateKey(addCalendarDays(easter, -2)),
        dateKey(easter),
        dateKey(addCalendarDays(easter, 1)),
        dateKey(addCalendarDays(easter, 49)),
        dateKey(addCalendarDays(easter, 50))
      ]);
    }

    function isWorkingDay(date) {
      const day = weekday(date);
      if (day === 0 || day === 6) return false;
      if (FIXED_HOLIDAYS.includes(monthDayKey(date))) return false;
      if (EXTRA_CLOSED_DATES.includes(dateKey(date))) return false;
      if (movableHolidayKeys(date.year).has(dateKey(date))) return false;
      return true;
    }

    function nextWorkingDay(date) {
      let candidate = addCalendarDays(date, 1);
      while (!isWorkingDay(candidate)) candidate = addCalendarDays(candidate, 1);
      return candidate;
    }

    function addWorkingDays(date, numberOfDays) {
      let candidate = date;
      let remaining = numberOfDays;
      while (remaining > 0) {
        candidate = addCalendarDays(candidate, 1);
        if (isWorkingDay(candidate)) remaining -= 1;
      }
      return candidate;
    }

    function formatDate(date) {
      return roDateFormatter.format(new Date(Date.UTC(date.year, date.month - 1, date.day)));
    }

    class KsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const cutoffHour = Number(this.dataset.cutoffHour || 14);
        const minDays = Number(this.dataset.deliveryMinDays || 1);
        const maxDays = Number(this.dataset.deliveryMaxDays || 2);
        const now = getBucharestParts(new Date());
        const today = { year: now.year, month: now.month, day: now.day };
        const shipsToday = isWorkingDay(today) && now.hour < cutoffHour;
        const dispatchDate = shipsToday ? today : nextWorkingDay(today);
        const earliestDelivery = addWorkingDays(dispatchDate, minDays);
        const latestDelivery = addWorkingDays(dispatchDate, maxDays);
        const dispatchMessage = this.querySelector('[data-dispatch-message]');
        const deliveryMessage = this.querySelector('[data-delivery-message]');

        if (shipsToday) {
          dispatchMessage.textContent = `Comandă până la ora ${String(cutoffHour).padStart(2, '0')}:00 și expediem astăzi.`;
        } else {
          dispatchMessage.textContent = `Expediere estimată: ${formatDate(dispatchDate)}.`;
        }

        deliveryMessage.textContent = `Livrare estimată: ${formatDate(earliestDelivery)} – ${formatDate(latestDelivery)}.`;
      }
    }

    if (!customElements.get('ks-delivery-estimate')) {
      customElements.define('ks-delivery-estimate', KsDeliveryEstimate);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-bracelet-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ks-bracelet-size-guide]').forEach((guide) => {
      if (guide.dataset.initialized === 'true') return;

      const product = guide.closest('.m-main-product');
      const picker = product?.querySelector('variant-picker');
      const error = guide.querySelector('[data-ks-bracelet-size-error]');

      if (!product || !picker || !error) return;

      const label = picker.querySelector('.option-label--title');
      if (label) label.textContent = guide.dataset.chooseLabel;

      let selectionMade = new URLSearchParams(window.location.search).has('variant');

      const clearError = () => {
        error.hidden = true;
        picker.classList.remove('ks-bracelet-size-required');
      };

      product.addEventListener('change', (event) => {
        const target = event.target;
        const isMainPicker = target.closest('variant-picker') === picker;
        const isStickyPicker = target.matches('.m-sticky-addtocart [name="id"]');

        if (!isMainPicker && !isStickyPicker) return;

        selectionMade = true;
        window.requestAnimationFrame(clearError);
      });

      product.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          const variantId = form.querySelector('[name="id"]')?.value;
          if (selectionMade && variantId) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden = false;
          picker.classList.add('ks-bracelet-size-required');
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      });

      guide.dataset.initialized = 'true';
    });
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ks-delivery-estimate')) return;

    class KsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.timeZone = this.dataset.timeZone || 'Europe/Bucharest';
        this.locale = this.dataset.locale || 'ro-RO';
        this.cutoffHour = Number(this.dataset.cutoffHour || 14);
        this.rangeNode = this.querySelector('[data-ks-delivery-range]');
        this.promptNode = this.querySelector('[data-ks-delivery-prompt]');
        this.openButton = this.querySelector('[data-ks-delivery-open]');
        this.dialog = this.querySelector('[data-ks-delivery-dialog]');
        this.closeButton = this.querySelector('[data-ks-delivery-close]');
        this.partsFormatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
        this.dateFormatter = new Intl.DateTimeFormat(this.locale, {
          timeZone: 'UTC',
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
        this.handleOpen = () => this.openDialog();
        this.handleDialogClick = (event) => {
          if (event.target === this.dialog) this.dialog.close();
        };
        this.handleDialogClose = () => this.openButton?.focus();
        this.openButton?.addEventListener('click', this.handleOpen);
        this.dialog?.addEventListener('click', this.handleDialogClick);
        this.dialog?.addEventListener('close', this.handleDialogClose);
        this.renderEstimate();
        this.timer = window.setInterval(() => this.renderEstimate(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.openButton?.removeEventListener('click', this.handleOpen);
        this.dialog?.removeEventListener('click', this.handleDialogClick);
        this.dialog?.removeEventListener('close', this.handleDialogClose);
        this.initialized = false;
      }

      getZonedParts(date) {
        return this.partsFormatter.formatToParts(date).reduce((parts, part) => {
          if (part.type !== 'literal') parts[part.type] = Number(part.value);
          return parts;
        }, {});
      }

      getCalendarDate(year, month, day) {
        return new Date(Date.UTC(year, month - 1, day));
      }

      isBusinessDay(date) {
        const weekday = date.getUTCDay();
        return weekday !== 0 && weekday !== 6;
      }

      nextBusinessDay(date) {
        const result = new Date(date);
        do {
          result.setUTCDate(result.getUTCDate() + 1);
        } while (!this.isBusinessDay(result));
        return result;
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let remaining = days;
        while (remaining > 0) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (this.isBusinessDay(result)) remaining -= 1;
        }
        return result;
      }

      formatRemainingTime(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const hourLabel = hours === 1 ? this.dataset.hourOne : this.dataset.hoursMany;
        const minuteLabel = minutes === 1 ? this.dataset.minuteOne : this.dataset.minutesMany;

        if (hours > 0 && minutes > 0) {
          return `${hours} ${hourLabel} ${this.dataset.timeAnd} ${minutes} ${minuteLabel}`;
        }
        if (hours > 0) return `${hours} ${hourLabel}`;
        if (minutes > 0) return `${minutes} ${minuteLabel}`;
        return this.dataset.lessThanMinute;
      }

      renderEstimate() {
        if (!this.rangeNode || !this.promptNode) return;
        const now = new Date();
        const local = this.getZonedParts(now);
        const today = this.getCalendarDate(local.year, local.month, local.day);
        const cutoffSeconds = this.cutoffHour * 3600;
        const currentSeconds = local.hour * 3600 + local.minute * 60 + local.second;
        const processesToday = this.isBusinessDay(today) && currentSeconds < cutoffSeconds;
        const processingDate = processesToday ? today : this.nextBusinessDay(today);
        const deliveryStart = this.addBusinessDays(processingDate, 1);
        const deliveryEnd = this.addBusinessDays(processingDate, 2);

        this.rangeNode.textContent = `${this.dateFormatter.format(deliveryStart)} – ${this.dateFormatter.format(deliveryEnd)}`;

        if (processesToday) {
          const remainingTime = this.formatRemainingTime(Math.max(0, cutoffSeconds - currentSeconds));
          this.promptNode.textContent = this.dataset.countdownTemplate.replace('__TIME__', remainingTime);
          this.promptNode.hidden = false;
        } else {
          this.promptNode.hidden = true;
          this.promptNode.textContent = '';
        }
      }

      openDialog() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        window.requestAnimationFrame(() => this.closeButton?.focus());
      }
    }

    customElements.define('ks-delivery-estimate', KsDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

})();
